/**
 * navOpen.js
 * Handles toggling off-screen navigation
 *
 */
export default class credits {

    constructor() {

        this.settings = {
            credits: document.querySelectorAll('.image-credit'),
            activeClass: "credit--active"
        }

    }

    init() {

        if (null !== this.settings.credits) {
            this.bindUIActions();
        }

    }

    bindUIActions() {

        const { credits } = this.settings;

        credits.forEach( credit => {
            let button = credit.querySelector('button');

            button.addEventListener( 'click', () => {
                this.activeClass(button);
            })
        })

    }

    activeClass(element) {

        const { activeClass } = this.settings;

        if (element.classList.contains(activeClass)) {
            element.classList.remove(activeClass);
        } else {
            element.classList.add(activeClass);
        }

    }

}
